/** @jsx h */
import { h } from 'preact'
import { useRef } from 'preact/compat'
import Icon from './icons/icons'
import clsx from 'clsx'
import { useGlobal } from '../use-global'

const Select = ({
  style = {},
  options,
  name,
  required,
  id,
  label,
  placeholder,
  hasError,
  disabled,
  value,
  onChange,
  ariaLabel,
  className
}) => {
  const [{ canvasConfig }] = useGlobal()

  const selectRef = useRef(null)
  return (
    <div className={clsx(`rcc_c_select-component rcc-relative`, className)} style={style}>
      {label && (
        <label
          className={clsx(
            'rcc-text-sm rcc-block rcc-mb-2.5',
            { 'rcc-text-danger': hasError },
            { 'rcc-text-gray': !hasError },
            { 'rcc-text-right': canvasConfig.direction === 'rtl' }
          )}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <select
        id={id}
        disabled={disabled}
        onChange={onChange}
        ref={selectRef}
        className={clsx(
          'rcc-text-text rcc-border rcc-w-full rcc-text-sm rcc-px-4 rcc-py-3 rcc-pr-7 rcc-h-[50px] rcc-appearance-none rcc-font-widget',
          { 'rcc-border-danger': hasError },
          { 'rcc-border-gray-light': !hasError },
          { 'rcc-text-right': canvasConfig.direction === 'rtl' }
        )}
        name={name}
        value={value}
        required={required}
        aria-label={ariaLabel}
        data-cs-mask
      >
        <option value='' selected={!!placeholder} disabled={!!placeholder}>
          {placeholder}
        </option>
        {options?.map((option, index) => {
          return (
            <option key={index} value={option.value} selected={option.value === value}>
              {option.label}
            </option>
          )
        })}
      </select>
      <Icon
        name='arrow-next'
        className={clsx('rcc-block rcc-absolute rcc-right-5 rcc-bot-0 rcc-translate-y-[-30px] rcc-rotate-90', {
          'rcc-left-5 rcc-right-0': canvasConfig.direction === 'rtl'
        })}
      />
    </div>
  )
}

export default Select
